import React from "react";
import TripDetails from "./TripDetails";
import VariantDetails from "./VariantDetails";
import "../css/TripAndVariantDetails.css";

const TripAndVariantDetails = ({ showVariantDetails }) => {
  return (
    <div className="trip-and-variant-container">
      <div className="content-wrapper">
        {showVariantDetails ? <VariantDetails /> : <TripDetails />}
      </div>
       <div style={{ height: "80px" }} />
    </div>
  );
};

export default TripAndVariantDetails;
